import {
  INITIAL_PRESET_LOADED,
  SET_CURRENT_PRESET,
  SAVE_PRESET,
  ADD_PRESET,
  SAVE_NEW_PRESET,
  CANCEL_SAVE_AS_PRESET,
  DELETE_PRESET,
  REVERT_PRESET,
  SELECT_PRESET,
  SELECT_PRESET_DESTINATION,
  SET_USER_PRESET_NAME,
  DOWNLOAD_USER_PRESETS
} from './actionTypes'

import {
  exportLocalStorage,
  getNextPreset,
  getPresetFromID,
} from "../utilities";

import {
  loadPreset,
  sendPreset,
  requestUserCurve,
  setRevertablePreset,
} from './'

export const selectPreset = (presetID) => ({ type: SELECT_PRESET, selectedPreset: presetID });
export const selectPresetDetination = (destination) => ({ type: SELECT_PRESET_DESTINATION, destination: destination });

export const deletePreset = (name, presets) => {
  const { nextSelectPresetID, nextPreset } = getNextPreset(name, presets)

  return (dispatch) => {
    dispatch({ type: DELETE_PRESET, name: name })
    dispatch({ type: SET_CURRENT_PRESET, preset: nextPreset })
    dispatch({ type: SELECT_PRESET, selectedPreset: nextSelectPresetID })
    dispatch(setRevertablePreset(false))
    dispatch(sendPreset(nextPreset))
  }
};

export const setCurrentPreset = (preset, id) => {
  return (dispatch) => {
    dispatch({ type: SET_CURRENT_PRESET, preset: preset })
    dispatch({ type: SELECT_PRESET, selectedPreset: id })

    if(id.includes('device')) {
      let [, devicePresetIndex] = id.split('-')

      dispatch(loadPreset(~~devicePresetIndex + 1))
    } else {
      dispatch(sendPreset(preset))
    }

    dispatch(setRevertablePreset(false))
  }
};

export const setCurrentPresetFromID = (id) => {
  return (dispatch, getState) => {
    const presets = getState().presets;
    const preset = getPresetFromID(presets, id);
    dispatch({ type: SET_CURRENT_PRESET, preset: preset })
    dispatch({ type: SELECT_PRESET, selectedPreset: id })

    if(id.includes('device')) {
      let [, devicePresetIndex] = id.split('-')

      dispatch(loadPreset(~~devicePresetIndex + 1))
    } else {
      dispatch(sendPreset(preset))
    }

    dispatch(setRevertablePreset(false))
  }
};

export const initialPresetLoad = (preset, id) => {
  console.log(`>> malletStation Editor - initial preset loaded: '${preset.name}' (${id})`);
  return (dispatch) => {
    dispatch({ type: INITIAL_PRESET_LOADED })
    dispatch(setCurrentPreset(preset, id))
    dispatch(requestUserCurve('0'))
    dispatch(requestUserCurve('1'))
    dispatch(requestUserCurve('2'))
    dispatch(requestUserCurve('3'))
  }
}

export const revertPreset = (preset) => {
  return (dispatch) => {
    dispatch({ type: SET_CURRENT_PRESET, preset: preset })
    dispatch(sendPreset(preset))
    dispatch(setRevertablePreset(false))
    dispatch({ type: REVERT_PRESET })
  }
}

export const addPreset = (category, preset) => ({ type: ADD_PRESET, category: category, preset: preset });

export const savePresetToStorage = (preset, id) => {
  return (dispatch) => {
    dispatch({ type: SAVE_PRESET, preset: preset, id: id})
    dispatch(setRevertablePreset(false))
  }
};

export const saveNewPreset = (preset, name) => {
  return (dispatch) => {
    dispatch({ type: SAVE_NEW_PRESET, category: 'user', preset: preset, name: name })
    dispatch(setRevertablePreset(false))
    dispatch({ type: REVERT_PRESET })
  }
};

// unsaved dialog: save, store, reset revertable - saveNewPreset
// user preset dialog: save, store, currentPreset, send - saveAndSelectNewPreset 

export const saveAndSelectNewPreset = (preset, name) => {
  const newPreset = Object.assign(preset, { name: name });
  return (dispatch, getState) => {
    dispatch({ type: SAVE_NEW_PRESET, category: 'user', preset: preset, name: name })
        // select newly saved preset / update name in current preset
    dispatch({ type: SET_CURRENT_PRESET, preset: newPreset })
    // select new preset in menu
    dispatch({ type: SELECT_PRESET, selectedPreset: `user-${getState().presets.user.length - 1}` })
    dispatch(setRevertablePreset(false))
    dispatch({ type: REVERT_PRESET })
    // send preset to device
    dispatch(sendPreset(newPreset));
  }
};
export const setUserPresetName = (presetName) => ({ type: SET_USER_PRESET_NAME, name: presetName });
export const cancelSaveAsPreset = () => ({ type: CANCEL_SAVE_AS_PRESET });

export const downloadUserPresets = () => {
  exportLocalStorage()
  return {type: DOWNLOAD_USER_PRESETS}
}
